// Written in this round about way for babel-transform-imports
import withRouter from "react-router/es/withRouter";

export default withRouter;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-dom/es/withRouter.js
// module id = 154
// module chunks = 0